import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/utils.scss'
import '@/assets/icon/iconfont.css'
import Mixin from './mixin'
import 'lib-flexible'


// 适配rem
// (function (doc, win) {
//   var docEl = doc.documentElement
//   var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
//   var recalc = function () {
//     var clientWidth = docEl.clientWidth
//     if (!clientWidth) return
//     docEl.style.fontSize = 20 * (clientWidth / 1920) + 'px'
//   }
//   if (!doc.addEventListener) return
//   win.addEventListener(resizeEvt, recalc, false)
//   doc.addEventListener('DOMContentLoaded', recalc, false)
// })(document, window)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.mixin(Mixin)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 页面跳转位置头部
router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})